module.exports = __webpack_public_path__ + "img/icon_promotion_on.3920e67a.svg";